var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIconFootNotesWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 10C2.23858 10 0 7.76142 0 5C0 2.23857 2.23858 0 5 0C7.76142 0 10 2.23857 10 5C10 7.76142 7.76142 10 5 10ZM5 0.714285C2.63306 0.714285 0.714285 2.63307 0.714285 5C0.714285 7.36693 2.63307 9.28571 5 9.28571C7.36693 9.28571 9.28571 7.36693 9.28571 5C9.28571 2.63306 7.36693 0.714282 5 0.714285Z",
    fill: "#C50F3C"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.64258,
    y: 2.14258,
    width: 1,
    height: 3.92857,
    fill: "#C50F3C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00056 6.78613C4.70469 6.78613 4.46484 7.02598 4.46484 7.32185C4.46484 7.61771 4.70469 7.85756 5.00056 7.85756C5.29642 7.85756 5.53627 7.61771 5.53627 7.32185C5.53627 7.02598 5.29642 6.78613 5.00056 6.78613Z",
    fill: "#C50F3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIconFootNotesWarning);
export default __webpack_public_path__ + "static/media/infoIconFootNotesWarning.773d333c232eec4cc9f9326c1287f84e.svg";
export { ForwardRef as ReactComponent };